Namespace 'Common.Sessions'

class Common.Sessions.SessionChartsView extends Backbone.View
  template: JST['backbone/templates/common/dashboard/charts/session_charts']
  id: 'session-charts'

  initialize: ({session, chartListItemCollectionViewFactory, isReadOnly = false, isResponsive = false}) ->
    @session = session
    @chartViewFactory = new CustomerVisualMode.Charts.ChartViewFactory(session)
    @chartsLoadingPlaceholderView = new Common.Dashboard.Charts.ChartsLoadingPlaceholderView
    @navbarView = new Common.Dashboard.Charts.NavbarView(
      session: @session
      lastUpdatedDate: @lastUpdatedDate
      chartListItemCollectionViewFactory: chartListItemCollectionViewFactory
    )
    @isReadOnly = isReadOnly
    @isResponsive = isResponsive
    @chartViews = []
    @listenTo(@session.getWidgetCollection(), 'session:widgets:add:finished', @onWidgetAdded)
    @listenTo(@session, 'session:filterChange', @onSuccess)
    @listenTo(@session, 'session:execution:finished', @onSuccess)
    @listenTo(@session, 'session:updateChartOrder', @masonry)
    @listenTo(@session, 'session:widgets:add:pending', @addPlaceholder)
    @executeSession()

  render: =>
    @$el.html(@template)
    @renderNavbar() unless @isReadOnly
    @renderCharts()
    @$el.find('.charts-loading-placeholder-container').html(@chartsLoadingPlaceholderView.render().el)
    @$('.refresh-dashboard').click(@executeSession)
    @

  renderCharts: =>
    @chartContainer = @$el.find('#chart-container')
    @chartsEl().remove()
    for chartId, data of @sessionExecutionResult
      widget = @session.getWidgetCollection().get(chartId)
      if data.invalid_result
        widget.set('type', CustomerVisualMode.Charts.InvalidChartView.NAME)
      @createChart(widget, data) if widget
    @masonry()

  renderNavbar: ->
    @$('.navbar-container').html(@navbarView.render().el)

  sessionWidgetIds: ->
    @session.getWidgetCollection().getWidgetIds()

  createChart: (widget, data) ->
    type = widget.get('type')
    chart = @chartViewFactory.create(widget, data, @isReadOnly, @isResponsive)
    return unless chart
    @chartViews.push(chart)
    chart.appendChart(@chartContainer)
    @listenTo(chart, 'masonry', @masonry)
    @listenTo(chart, 'asc', @_sortAsc)
    @listenTo(chart, 'desc', @_sortDesc)
    @listenTo(chart, 'removed', @_onChartRemoved)

  masonry: =>
    callback = =>
      @chartContainer.masonry
        columnWidth: '.grid-sizer',
        gutter: '.gutter-sizer',
        itemSelector: '.grid-item'
      @chartContainer.masonry('reloadItems')
    setTimeout callback, 100

  executeSession: =>
    @session.execute()

  onSuccess: (response) =>
    @sessionExecutionResult = response.widgets
    @renderCharts()

  onWidgetsUpdate: =>
    @navbarView.renderChartList()
    @$('.refresh-dashboard').click(@executeSession)

  onWidgetAdded: (response) =>
    widget = Object.entries(response.widgets)[0]
    @_renderSingleChart(chartId: widget[0], data: widget[1])

  addPlaceholder: =>
    @chartContainer = @$el.find('#chart-container')
    chartsLoadingPlaceholderEl = @chartsLoadingPlaceholderView.render().el
    @chartContainer
      .append(chartsLoadingPlaceholderEl)
      .masonry('appended', chartsLoadingPlaceholderEl)
      .masonry()

  _renderSingleChart: ({chartId, data}) =>
    @chartContainer = @$el.find('#chart-container')
    @chartContainer.find('.charts-loading-placeholder')?.remove()
    widget = @session.getWidgetCollection().get(chartId)
    return unless widget
    @createChart(widget, data)
    @chartContainer.masonry('reloadItems')
    @masonry()

  _sortAsc: (chart) =>
    operation = (index) -> index - 1
    condition = (index) -> index == 0
    sort = ($chart, $chartToChange) -> $chartToChange.insertAfter($chart)

    @_sort(chart, operation, condition, sort)

  _sortDesc: (chart) ->
    operation = (index) -> index + 1
    condition = (index) => index + 1 == @sessionWidgetIds().length
    sort = ($chart, $chartToChange) -> $chart.insertAfter($chartToChange)

    @_sort(chart, operation, condition, sort)

  _sort: (chart, operation, condition, sort) =>
    index = @sessionWidgetIds().indexOf(chart.widget.id)

    return if condition(index)

    indexToChange = operation(index)

    # Reorder widgets list
    @session.getWidgetCollection().swapWidgets(index, indexToChange)
    # Reorder widgets DOM
    widgets = @chartsEl()
    sort(widgets.eq(index), widgets.eq(indexToChange))
    @chartContainer.masonry('reloadItems')
    @masonry()

  chartsEl: =>
    @chartContainer.children('.grid-item')

  _onChartRemoved: (removedChartId) ->
    @chartViews = @chartViews.filter((chartView) -> chartView.widget.id != removedChartId)
    @chartContainer.masonry('reloadItems')
    @masonry()

  onFiltersMenuToggle: =>
    @chartViews.forEach((chartView) -> chartView.onWidthChange())
    @masonry()
